import React from 'react';

const Review = () => {
    return (
        <div>
            <h1 className='text-2xl ml-6 mt-6 font-bold'>Review </h1>
            
        </div>
    );
};

export default Review;